import { axios as request } from "../../request/http";

const interfaceUrl = {
  "api_productSkuList": "/product/sku/queryList", // product
  "api_productSkuAdd": "/product/sku/add", // 
  "api_productSkuDisable": "/product/sku/disable", // 下架SKU
  "api_productSkuEnable": "/product/sku/enable", // 上架SKU
  "api_productSkuUpdate": `/product/sku/update`, // 
  "api_productSkuDetail": "/product/sku/queryDetail", // 查询明细SKU
}

// initial state
const state = {
  productSkuList: {},
  productSkuDetail: {}
}

// getters
const getters = {
  getProductSkList: state => {
    return state.productSkuList
  },
  getProductSkuDetail: state => {
    return state.productSkuDetail
  },
}

// actions
const actions = {
  getProductSkList: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_productSkuList,
      method: "GET",
      params,
    };
    return request(option).then(res => res.data).then(res => {
      if (res.code == 200) {
        commit('PRODUCT_SKU_LIST', res || {});
      } else {
        commit('PRODUCT_SKU_LIST', {});
      }
    }).catch(err => {
      commit('PRODUCT_SKU_LIST', {});
    })
  },
  productSkuAdd: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_productSkuAdd,
      method: "POST",
      data: params,
    };
    return request(option).then(res => res.data)
  },
  productSkuDisabled: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_productSkuDisable,
      method: "POST",
      data: params,
    };
    return request(option).then(res => res.data)
  },
  productSkuEnable: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_productSkuEnable,
      method: "POST",
      data: params,
    };
    return request(option).then(res => res.data)
  },
  productSkuUpdate: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_productSkuUpdate,
      method: "POST",
      data: params,
    };
    return request(option).then(res => res.data)
  },
  getProductSkuDetail: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_productSkuDetail,
      method: "GET",
      params,
    };
    return request(option).then(res => res.data).then(res => {
      if (res.code == 200) {
        commit('PRODUCT_SKU_DETAIL', {
          status: "success",
          data: res.data
        });
      } else {
        commit('PRODUCT_SKU_DETAIL', {
          status: "error",
          data: res.data
        });
      }
    }).catch(err => {
      commit('PRODUCT_SKU_DETAIL', {
        status: "error",
        data: {}
      });
    })
  },
}


// mutations
const mutations = {
  PRODUCT_SKU_LIST: (state, pageData) => {
    state.productSkuList = pageData;
  },
  PRODUCT_SKU_DETAIL: (state, pageData) => {
    state.productSkuDetail = pageData;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/skuInfo.js